import React from "react"
import { InputTextFloatLabel } from "~components/input-text"
import { rules } from "~utils/validator"

interface Props {
  value: string
  placeholder?: string
  onChange: (value: string) => void
}

const Password: React.FC<Props> = ({ value, onChange, ...rest }) => (
  <InputTextFloatLabel
    label="密码"
    secureTextEntry={true}
    keyboardType={"ascii-capable"}
    placeholder={"请输入密码"}
    autoComplete="current-password"
    textContentType="password"
    value={value}
    onChangeText={onChange}
    validRule={rules.password}
    {...rest}
  />
)

export default Password
